























import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Getter, Mutation, namespace } from 'vuex-class'
import Card from '../BaseCard.vue'
import CardContent from '../BaseCardContent.vue'
import Instructions from '../BaseInstructions.vue'
import Notification from '../BaseNotification.vue'
import Button from '../BaseButton.vue'
import { stripePublishableKey } from '../../utils/computed'

const cart = namespace('cart')
const user = namespace('user')
const stripe = window.Stripe(stripePublishableKey)
const elements = stripe.elements()
let card: any

@Component({
  components: { Instructions, Notification, Button, Card, CardContent }
})
export default class PaymentInfo extends Vue {
  @cart.State processingError: string
  @cart.State processing: boolean
  @cart.State useStoredPaymentInfo: boolean
  @user.State cardMeta: any
  @cart.Getter isStoredInfo: boolean
  @cart.Getter grandTotal: number
  @cart.Mutation editStoredPaymentInfo: boolean
  @cart.Mutation setProcessing: any
  @cart.Mutation setProcessingError: any
  @cart.Action attemptPurchase: (token: any) => Promise<void>

  paymentErrorMessage: string | null = null
  success: boolean = false

  mounted () {
    card = card || elements.create('card', {
      hidePostalCode: true,
      style: {
        base: {
          fontFamily: 'Jost, "Helvetica Neue", Helvetica, sans-serif',
          fontSize: '18px',
        }
      }
    })
    card.on('change', this.handlePaymentInfoChange)
    card.mount(this.$refs.card)
  }

  handlePaymentInfoChange (e: any) {
    this.success = e.complete
  }

  get paymentPrompt () {
    return this.grandTotal > 0 ? 'Your Payment Method' : 'Complete Order'
  }

  async purchase () {
    if (!this.isStoredInfo && this.grandTotal > 0) {
      this.setProcessingError(null)
      this.setProcessing(true)
      const result = await stripe.createToken(card)

      if (result.error) {
        this.paymentErrorMessage = result.error.message
        this.$forceUpdate() // force the DOM to update so Stripe can update
        this.setProcessing(false)
        return
      }

      this.attemptPurchase(result.token)
    } else {
      this.attemptPurchase(null)
    }
  }
}
